import { Link, Outlet, NavLink, useNavigate } from "react-router-dom";
import { Leaf, LogOut, Sparkles, Tag, Ticket, Gauge, MessageSquareQuote } from "lucide-react";
import { useAdminAuth } from "./AdminAuth";
import AdminLogin from "./AdminLogin";

export default function AdminLayout() {
  const { user, loading, logout } = useAdminAuth();
  const navigate = useNavigate();

  if (loading) {
    return <div className="auth-shell"><div className="auth-card"><p className="muted" data-testid="admin-auth-loading">Loading…</p></div></div>;
  }
  if (!user) return <AdminLogin />;

  const items = [
    { to: "/admin", label: "Overview", icon: Gauge, end: true, testid: "admin-nav-overview" },
    { to: "/admin/seo", label: "AI SEO Helper", icon: Sparkles, testid: "admin-nav-seo" },
    { to: "/admin/offers", label: "Offers", icon: Tag, testid: "admin-nav-offers" },
    { to: "/admin/vouchers", label: "Vouchers", icon: Ticket, testid: "admin-nav-vouchers" },
    { to: "/admin/reviews", label: "Reviews", icon: MessageSquareQuote, testid: "admin-nav-reviews" },
  ];

  return (
    <div className="admin-shell" data-testid="admin-shell">
      <aside className="admin-sidebar">
        <Link to="/admin" className="brand" data-testid="admin-brand-link">
          <span className="brand-mark"><Leaf size={17} /></span>
          <span>ZORBA<small>ADMIN</small></span>
        </Link>
        <nav className="admin-nav">
          {items.map((it) => (
            <NavLink key={it.to} to={it.to} end={it.end} data-testid={it.testid}>
              <it.icon size={16} /> {it.label}
            </NavLink>
          ))}
        </nav>
        <div className="admin-user">
          {user.picture && <img src={user.picture} alt="" />}
          <div>
            <strong data-testid="admin-user-name">{user.name}</strong>
            <span className="muted-small" data-testid="admin-user-email">{user.email}</span>
          </div>
          <button
            className="icon-btn"
            onClick={async () => { await logout(); navigate("/admin/login"); }}
            aria-label="Sign out"
            data-testid="admin-logout-button"
          >
            <LogOut size={16} />
          </button>
        </div>
      </aside>
      <main className="admin-main"><Outlet /></main>
    </div>
  );
}
